import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  inject
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'coin-truncated-text',
  templateUrl: './truncated-text.component.html',
  styleUrls: ['./truncated-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip, NgStyle]
})
export class TruncatedTextComponent implements AfterViewInit, OnChanges {
  private readonly cdr = inject(ChangeDetectorRef);

  @ViewChild('textElement', { static: false }) textElement: ElementRef<HTMLElement>;
  @Input({ required: true }) text: string;
  @Input() addClass: string;
  @Input() lines = 1;

  public isTextTruncated: boolean;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.text) {
      this.checkTextTruncation();
    }
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.checkTextTruncation();
    });

    if (this.textElement && this.textElement.nativeElement) {
      const resizeObserver = new ResizeObserver(entries => {
        entries.forEach(() => {
          this.checkTextTruncation();
        });
      });

      resizeObserver.observe(this.textElement.nativeElement);
    }
  }
  private checkTextTruncation(): void {
    if (this.textElement) {
      this.isTextTruncated =
        this.textElement.nativeElement.offsetWidth < this.textElement.nativeElement.scrollWidth ||
        this.textElement.nativeElement.offsetHeight < this.textElement.nativeElement.scrollHeight;

      this.cdr.detectChanges();
    }
  }
}
